import React from 'react'

const ExperimentContext = React.createContext<Partial<Record<string, string>>>(
  {}
)
ExperimentContext.displayName = 'ExperimentContext'

export default ExperimentContext
